import React from 'react';
import { Link } from 'react-router-dom';
import { buildControlHref } from '../../ProfilePage/tabs/profileControl';

/**
 * ТЗ №1 §7.1 п.9: маленькая secondary карточка; полный Control Health — в ЛК.
 * FE-CORR-07 FE-001: ссылка несёт период «Обзора» (preset/from/to).
 */
const ControlStateCard = ({ controlContinuity, period }) => (
  <section className="sum-card sum-card--compact">
    <h2 className="sum-card-title">Состояние контроля сейчас</h2>
    <div className="sum-control-now">
      <span><b>{controlContinuity.cameras_online_now}</b> онлайн</span>
      <span><b>{controlContinuity.cameras_offline_now}</b> офлайн</span>
      <span><b>{controlContinuity.cameras_stopped_now}</b> остановлено</span>
    </div>
    <Link className="sum-link" to={buildControlHref(period)}>Непрерывность контроля</Link>
  </section>
);

export default ControlStateCard;
